<template lang="html">

  <div class="wrapper -empresas">

    <div class="encabezado">

      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Empresas</h1>
      </div>

    </div>


    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.empresas')">Empresas</router-link>
        </nav>
      </div>
    </div>


    <destacados :position="'5'"></destacados>


    <!-- <section class="empresas">

      <h2>Empresas colaboradoras</h2>

      <div class="contenedor-imagenes row-center container">

        <div class="imagen">
          <img src="/static/img/empresas/abogados.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/accenture.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/alantra.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/alfa-zulu.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/allen.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/aon.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/arcano.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ashurst.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/atos.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/atresmedia.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/axicon.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/bacman.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/badland.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/bai.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/baker.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/bankinter.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/brandipia.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/campofrio.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/champell.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/civismo.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/clifford.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/cuerdos.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/deloitte.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/dentons.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ecija.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/erasmus.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/erretres.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/exclama.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ey.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ford.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/fundacion.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/galeria.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/garrigues.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/globomedia.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/good.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/herbert.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/hogan.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/iberdrola.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/indra.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/infinit.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/jorge-alcolea.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/keywords.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/king.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/kpmg.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/liven.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/loewe.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/loreal.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mahou.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/management.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mapfre.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mazars.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mazda.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mccann.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mediaset.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/morwen.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/mutua.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/nielsen.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/nupa.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ogilvy.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ontier.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/perez-llorca.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/pgr.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/podo.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/portonovo.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/pwc.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/repsol.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/rtve.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/rushmore.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/sagardoy.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/shiseido.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/sohuman.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/squire.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/tbwa.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/teatro.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/tribalyte.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/true-sushi.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/true-sushi.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/ubisoft.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/uria.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/utad.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/vallmont.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/venuesplace.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/verdegay.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/watson.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/worldgate.png" alt="">
        </div>
        <div class="imagen">
          <img src="/static/img/empresas/wpp.png" alt="">
        </div>



      </div>

    </section> -->

    <section class="proyecto-formativo">
      <div class="container column-center empresas">
        <div class="texto">
          <h2 class="big-bold-title empresas">Nuestro proyecto formativo</h2>
          <p>Nuestro proyecto formativo responde a quiénes somos como Institución: Una comunidad universitaria de
            personas
            que buscan la verdad, el bien y la belleza, y que, por su formación y liderazgo, promueven la transformación
            cristiana de la sociedad y de la cultura.
          </p>
          <div class="btn-empresas">
            <a @click="showproyectoformativo = !showproyectoformativo"
              class="btn -skull -white info">{{(!showproyectoformativo) ? 'Más' : 'Menos'}} información</a>
          </div>
        </div>
        <div>
          <img style="width:100%" src="/static/img/imagen-empresa.png">
        </div>
      </div>
      <template v-if="showproyectoformativo">
        <div class="container column-center pilares">
          <h3>Pilares de nuestro proyecto formativo</h3>
          <ul class="pilares row-start">
            <li><span>Centralidad de la persona</span></li>
            <li><span>Formación integral</span></li>
            <li><span>Somos comunidad</span></li>
            <li><span>Síntesis de saberes</span></li>
            <li><span>Servicio al bien común</span></li>
            <li><span>Acompañamiento personal y comunitario</span></li>
            <li><span>Búsqueda comunitaria de la verdad, el bien y la belleza</span></li>
          </ul>
          <div class="final-pilares">
            <p>Conforme a los pilares en los que nuestro proyecto se sustenta, a través de nuestra particular forma de
              enseñar, las experiencias que la vivencia universitaria aportan al alumno y el diseño de los planes de
              estudios, el perfil del alumno UFV, <span>tiene unas connotaciones comunes que impactarán en el desempeño
                de su
                profesión:</span></p>
            <br><br>
            <ul>
              <li><span><span>Juicio crítico</span> y capacidad de hacerse grandes preguntas sobre su ejercicio
                  profesional y el sentido de
                  las acciones y decisiones que lleva a cabo.</span></li>
              <li><span><span>Colaborativo</span> al saberse necesitado de otros para una comprensión más profunda de la
                  realidad, y por
                  haber aprendido que junto a otros los <span>resultados son exponencialmente mejores y
                    mayores.</span></span></li>
              <li><span><span>Entendimiento de la profesión al servicio</span> de las personas y de la sociedad, y
                  solidaridad y entrega a
                  los demás y en su quehacer.</span></li>
            </ul>
          </div>
        </div>
      </template>

    </section>




    <section class="accesos -small row-center container ais">

      <article class="column-center publica-oferta">
        <div>
          <h2>Publica tus ofertas</h2>
          <p>Accede al portal de prácticas y empleo para publicar ofertas dirigidas a nuestros alumnos y alumni.</p>
        </div>
        <a href="https://portalcarrerasprofesionales.ufv.es/login/empresas" target="_blank" class="btn -skull -white">Acceder</a>
        <a href="https://portalcarrerasprofesionales.ufv.es/login/empresas" target="_blank" class="enlace-cover"></a>
      </article>
      <article class="column-center perfiles-ufv">
        <div>
          <h2>Perfiles UFV</h2>
          <p>¿La oferta académica de la UFV es muy amplia? Consúltala en la web.</p>
        </div>
        <a href="https://www.ufv.es/oferta-formativa/" target="_blank" class="btn -skull -white">Ir a la web</a>
        <a href="https://www.ufv.es/oferta-formativa/" target="_blank" class="enlace-cover"></a>
      </article>
      <article class="column-center formas-colaborar">
        <div>

          <h2>Otras formas de colaborar</h2>
          <p>Las formas de colaborar con nuestra Institución son múltiples. Siempre estamos abiertos a caminar junto a
            otros.</p>
        </div>
        <router-link to="/contacto"  class="btn -skull -white">Saber más</router-link>
        <router-link to="/contacto"  class="enlace-cover"></router-link>
      </article>



    </section>



    <section class="conectados-home">


      <div class="container row-between ais">


        <img src="/static/img/imagen-conectados.svg" class="imagen-conectados" alt="Imagen Conectados">


        <div class="main-card">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="showsecondarycard" @click="showsecondarycard = false">
          <p>¿Recuerdas tus primeros pasos profesionales? Seguro que sentiste algunos miedos, inseguridades o
            necesitaste orientación y acompañamiento. Tu trayectoria, experiencia y conocimientos son muy valiosos para
            quien ahora comienza.</p>
          <p>¿Quieres apoyar a los jóvenes talentos?</p>
          <div class="boton-redondo"></div>

          <router-link :to="$t('enlaces.conectados') + '/profesional'" class="btn -skull -white">Conecta</router-link>
        </div>

        <div class="secondary-card" :show="showsecondarycard" @click="showsecondarycard = !showsecondarycard">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="!showsecondarycard">
          <p>Conocer en profundidad te ayuda a tomar decisiones. Si tienes dudas sobre un sector, industria, empresa. Te
            enfrentas a un proceso de selección y quieres información para prepararte bien... ante cualquier duda en las
            decisiones sobre tu carrera profesional, te ponemos en contacto con quien puede ayudarte.</p>
          <router-link :to="$t('enlaces.conectados') + '/alumno'" class="btn -skull -white">Conecta</router-link>
        </div>
      </div>

    </section>



  </div>

</template>

<script lang="js">

import bannerconectados from '@/components/parts/banner-conectados';
import aldiabanner from '@/components/parts/al-dia-banner';

import aldia from '@/components/view-parts/home/al-dia';

import destacados from '@/components/parts/destacados';

import Slick from 'vue-slick';

export default {
  name: 'empresas',
  data() {
    return {
      showproyectoformativo: false,
      slickOptions: {
        slidesToShow: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 3000,
        variableWidth: false
      },
    }
  },
  components: {
    'banner-conectados': bannerconectados,
    'al-dia-banner': aldiabanner,
    'al-dia': aldia,
    'destacados': destacados,
    Slick
  }
}
</script>

<style scoped lang="scss">
.accesos-home {
  article {
    padding: 65px 20px;
    justify-content: flex-start;

    h2 {
      min-height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:nth-child(1) {
      background: url(/static/img/acceso-empleabilidad.jpg) center/cover no-repeat;
    }

    &:nth-child(2) {
      background: url(/static/img/acceso-practica-proyecto.jpg) center/cover no-repeat;
    }

    &:nth-child(3) {
      background: url(/static/img/acceso-llegamos-mas-lejos.jpg) center/cover no-repeat;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/empresas.vue